export default {
    icons: [
        "&#xe67a;",
        "&#xe662;",
        "&#xe652;",
        "&#xe60c;",
        "&#xe602;",
        "&#xe68e;",
        "&#xe6a4;",
        "&#xe66a;",
        "&#xe66c;",
        "&#xec4d;",
        "&#xe751;",
        "&#xe7cc;",
        "&#xe60e;",
        "&#xe610;",
        "&#xe636;",
        "&#xe7f3;"
    ],
    wColor: {
        green: "#67C23A",
        blue: "#409EFF",
        yellow: "#fabb00",
        orange: "#ff6600",
        red: "#ff2222"
    },
    colors: ["#f0a800", "#eb5050", "#46c26f", "#00aed1", "#2f7deb", "#7e47eb"],
    nations: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "藏族",
        "鄂伦春族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "僳僳族",
        "佤族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "土族",
        "撒拉族",
        "毛南族",
        "畲族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "布朗族",
        "塔塔尔族",
        "京族",
        "基诺族",
        "门巴族",
        "白族",
        "珞巴族",
        "赫哲族",
        "高山族",
        "傣族",
        "布朗族",
        "撒拉族",
        "独龙族",
        "仫佬族",
        "水族"
    ],
};



// WEBPACK FOOTER //
// ./src/js/consts.js